import React from 'react';
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout';
import LiveFeedDashboard from '@/components/live-feed/LiveFeedDashboard';
import { useBrandAware } from '@/hooks/useBrandAware';
import { useLeadEmailProviderService } from '@/hooks/useLeadEmailProviderService';
import { useLeadEmailProviderRealtime } from '@/hooks/useLeadEmailProviderRealtime';

export default function LiveFeed() {
  const { getBrandStyles } = useBrandAware();
  const layoutStyles = getBrandStyles('layout');

  // Enable automatic processing of new email events for lead_email_provider
  useLeadEmailProviderService();

  // Enable real-time processing of new email events
  useLeadEmailProviderRealtime();

  return (
    <NewAppLayout fullWidth>
      <div style={layoutStyles}>
        <LiveFeedDashboard />
      </div>
    </NewAppLayout>
  );
}
